import { render, staticRenderFns } from "./counterNumber.vue?vue&type=template&id=accc5d1e&scoped=true&"
import script from "./counterNumber.vue?vue&type=script&lang=js&"
export * from "./counterNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "accc5d1e",
  null
  
)

export default component.exports